<script setup lang="ts">
    import { ModelType } from '~~/app/base/schemas/BaseSchema';
    import EndpointFactory from '~~/app/factories/EndpointFactory';
    import ModelFileEndpoint from '~~/app/common/endpoints/ModelFileEndpoint';
    import ModelFile from '~~/app/common/models/ModelFile';

    const endpoint = EndpointFactory.make(ModelType.MODEL_FILES) as ModelFileEndpoint;
    const { contextMenu, onAction, onPromise } = useModelContextMenu();
    const deleteButton = ref(null);

    const destroy = async (model: ModelFile) => {
        await deleteButton.value.loadUntil(onPromise(endpoint.destroy(model.getId())));
    };

    const modelFile = ref<ModelFile>();
    const isDeletable = ref(false);

    useListen(`common:model-file:context-menu:open`, (payload) => {
        modelFile.value = payload.model;
        isDeletable.value = modelFile.value.isExpenseDeletable;
    });

    /**
     * TODO: Improve this somehow...
     */
    const shouldDisplayMoveAction = computed(() => {
        return window.location.pathname.startsWith('/worksite/worksite');
    });

    onBeforeUnmount(() => {
        modelFile.value = undefined;
        isDeletable.value = false;
    });
</script>

<template>
    <ModelContextMenu
        v-slot="slotProps"
        ref="contextMenu"
        :model-type="ModelFile"
    >
        <a
            href="#"
            :class="$theme('contextmenu.link')"
            @click.prevent="onAction(() => slotProps.model?.preview())"
        >
            <i
                class="fa-eye"
                :class="$theme('contextmenu.icon')"
            ></i>
            <span>{{ $t('actions.open') }}</span>
        </a>
        <a
            v-if="shouldDisplayMoveAction"
            href="#"
            :class="$theme('contextmenu.link')"
            @click.prevent="onAction(() => useEvent('common:model-file:move-modal:open', { modelFile: slotProps.model }))"
        >
            <i
                class="fa-arrow-right"
                :class="$theme('contextmenu.icon')"
            ></i>
            <span>{{ $t('actions.move') }}</span>
        </a>
        <a
            v-if="slotProps.model?.isDownloadable()"
            href="#"
            :class="$theme('contextmenu.link')"
            @click.prevent="onAction(() => slotProps.model?.download())"
        >
            <i
                class="fa-download"
                :class="$theme('contextmenu.icon')"
            ></i>
            <span>{{ $t('actions.download') }}</span>
        </a>
        <LoadingButton
            v-if="isDeletable"
            ref="deleteButton"
            :disabled="!isDeletable"
            :class-name="$theme('contextmenu.link')"
            @click.prevent="destroy(slotProps.model)"
        >
            <i
                class="fa-trash"
                :class="$theme('contextmenu.icon')"
            ></i>
            <span>{{ $t('actions.delete') }}</span>
        </LoadingButton>
    </ModelContextMenu>
</template>
